import { useSplitFeatureFlag } from '@/shared/providers/feature-flags';
import { SplitFeatureFlag } from '@/shared/providers/feature-flags/splitConfig';

// [FF CLEANUP: LLX-4871_use_go_llp_be_get_me_endpoint]
type ModernGetMeRollout = {
  /**
   * Split has given an answer — or timed out and stopped blocking. Gate loaders on this, never on
   * `isReady` alone: if Split.io is unreachable `isReady` stays false for the whole session.
   */
  isResolved: boolean;
  /**
   * The Go /v1/me endpoint is enabled. False until Split answers; unreachable Split degrades to
   * legacy /me (safe default).
   */
  isEnabled: boolean;
  /** Diagnostics only: Split gave up reaching its CDN (SDK_READY_TIMED_OUT). */
  hasTimedout: boolean;
};

/**
 * Global rollout flag for GET /v1/me on landlord-portal-backend (Go).
 * When off, the app keeps using the legacy Node /api/v1/me endpoint.
 */
export const useModernGetMeRollout = (): ModernGetMeRollout => {
  const { isReady, hasTimedout, isFeatureFlagEnabled } = useSplitFeatureFlag(
    SplitFeatureFlag.LLX_4871_USE_GO_LLP_BE_GET_ME_ENDPOINT,
  );

  return {
    isResolved: isReady || hasTimedout,
    isEnabled: isReady && isFeatureFlagEnabled,
    hasTimedout,
  };
};
